import React from 'react';
import styled from 'styled-components';
import { useAuth } from '../../../../hooks/context/AuthContext';
import { ProfileArea } from '../ProfileArea';
import { ContinueButton } from '../../../../components/common/button/ContinueButton';
import { TitleWithGoBack } from '../Title';
import { PasswordInput } from '../../../../components/common/input/PasswordInput';
import Notification from '../../../../components/common/Notification';
import { useTranslation } from 'react-i18next';

const LoginBox = styled.div`
  background: white;
  padding: 60px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 600px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
`;

const SubTitle = styled.p`
  display: flex;
  flex-direction: column;
  gap: 5px;
  font-size: 20px;
  color: #666;
`;

const Link = styled.a`
  display: block;
  font-size: 20px;
  color: #0057ff;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

const AuthStep2 = () => {
  const {
    setStep,
    setLoginPassword,
    loginPassword,
    clickLoginSubmit,
    notiStatus,
    notiText,
    notiDisplay,
    changePasswordLink,
  } = useAuth();
  const { t } = useTranslation();

  const handleContinue = () => {
    clickLoginSubmit();
  };

  const handleFindPassword = () => {
    changePasswordLink();
    setStep(5);
  };

  const handlePasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setLoginPassword(event.target.value);
  };
  return (
    <div style={{ position: 'relative' }}>
      <Notification
        text={notiText}
        status={notiStatus}
        isDisplay={notiDisplay}
      />
      <LoginBox>
        <TitleWithGoBack title={t(`auth.typepassword`)} />
        <ProfileArea />
        <PasswordInput value={loginPassword} onChange={handlePasswordChange} />
        <ContinueButton onClick={handleContinue} title={t(`auth.next`)} />
        <SubTitle>
          <div>{t(`auth.forgetpassword`)}</div>
          <Link onClick={handleFindPassword}>{t(`auth.findpassword`)}</Link>
        </SubTitle>
      </LoginBox>
    </div>
  );
};

export default AuthStep2;
